/**
 * @fileOverview This file defines constant values for query parameters used across the qbook application.
 */

export const QUERY_FILE = "file";
export const QUERY_COURSE = "article";
export const QUERY_ADMIN_COURSE_ID = "courseId";
export const QUERY_ADMIN_COURSE_USER_ID = "courseIntId";
export const QUERY_ADMIN_COURSE_QUESTION_ID = "questionId";
export const QUERY_ADMIN_BLOG_ID = "blogId";

export const GRADER_SOLUTION_TYPE = "solutionType";
export const GRADER_SOLUTION_PAGE = "graderSolutionPage";
export const GRADER_SOLUTION_RESULTS_PER_PAGE = "graderSolutionResultsPerPage";
export const GRADER_SOLUTION_ID = "solutionId";
